angular.module('iqxCore').controller('ProvTimesheetCtrl', function ($scope, $routeParams, $q, $timeout, $filter, $http, $window, FormSvc, ApiSvc, ApplicationSvc, sendMessageDialogSvc, Upload, $location, SweetAlert, base64Svc, toastSvc, BehaviourSvc, TerminologySvc) {
  $scope.selects = {}
  $scope.selects.payBandType = {}
  $scope.paybandChanged = false
  $scope.emailList = []
  $scope.divisionTimesheetSigningRights = {}
  $scope.showSignForm = false
  $scope.signaturePad = {}
  $scope.ProvTSID = $routeParams.id
  $scope.terminology = {}
  FormSvc.setOptions($scope, {
    fetchAPI: 'callresult/NetProvTimesheet?pTempProvTimesheetID=' + $scope.ProvTSID,
    saveAPI: 'call/NetProvTimesheetSet',
    primaryKey: 'tempprovtimesheetid',
    savePrefix: 'p',
    dateFields: ['weekenddate'],
    booleanFields: ['theirrefrequired', 'completed', 'hasScannedImage', 'allowedToAuthorise', 'allowedToApprove', 'ShiftsOnContractTimesheet'],
    doNotPreventNav: true,
    questionnaire: {
      tagTarget: 'tags',
      id: $scope.ProvTSID,
      tagLocation: $scope.userHasRight('TSDEPARTMENTQS') ? 'T' + ApplicationSvc.currentUser.registrationDetails.DepartmentID : 'T',
      displayGroup: $scope.userHasRight('TSDEPARTMENTQS') && $scope.userClass() === 'CANDIDATE' ? false : $scope.userClass() == 'CLIENT' ? 'CLITSCOMP' : 'CANDTSCOMP',
      postVar: 'qanswers',
      questionGroup: $scope.userHasRight('TSDEPARTMENTQS') ? 10 : false
    }
  })

  $scope.classes = {
    label: 'col-sm-4',
    data: 'col-sm-6'
  } // Deliberatly not adding to 12 so as to indent from right margin

  $scope.fetchTimesheet = function () {
    // Fetch the timesheet header
    return $scope
      .fetch() // The primary fetch using the scope options above
      .then(function () {
        if ($scope.theRecord.tempprovtimesheetid) {
          $scope.state.loaded = true
        } else {
          $scope.state.loaded = false
          return $q.reject(FormSvc.alert('error', 'Timesheet not found', 'error'))
        }
      })
  }
  $scope.checkForShiftContent = function () {
    var haveBreaks = false,
      haveRefs = false,
      tempShiftID = ''
    angular.forEach($scope.timesheetShifts, function (sh) {
      if (sh.breakminutes) {
        haveBreaks = true
      }
      if (sh.referencecode) {
        haveRefs = true
      }
    })
    $scope.state.shiftBreaks = haveBreaks
    $scope.state.shiftRefs = haveRefs
  }

  $scope.fetchTimesheetShifts = function () {
    return $scope
      .fetch({
        fetchAPI: 'callresult/netprovtimesheetshifts?pTempProvTimesheetID=' + $scope.ProvTSID,
        fetchTarget: 'timesheetShifts',
        multiRow: true,
        dateFields: ['weekenddate', 'shiftdate'],
        timeFields: ['timefrom', 'timeto'],
        booleanFields: ['tick'],
        numberFields: ['breakminutes', 'shiftduration']
      })
      .then(function () {
        if (BehaviourSvc.isSwitchedOn('TSSCLIENTSIGNMULTI') === true) {
          return $scope.fetchClientSignatures()
        }
      })
      .then($scope.checkForShiftContent) // Sets state.shiftBreaks and state.shiftRefs as appropriate
      .then(function () {
        return $scope.fetch({
          fetchAPI: 'callresult/NetProvTimesheetShiftCheckDates?pTempProvTimesheetID=' + $scope.ProvTSID,
          fetchTarget: 'shiftDates',
          multiRow: false,
          dateFields: ['startdate', 'enddate']
        })
      })
      .then(function () {
        $scope.dateOptions = {
          initDate: $scope.shiftDates.startdate,
          minDate: $scope.shiftDates.startdate,
          maxDate: $scope.isSwitchedOn('TSBLOCKFUTURESHIFTS') && moment($scope.shiftDates.enddate).isAfter(moment()) ? moment().toDate() : $scope.shiftDates.enddate
        }
      })
  }
  $scope.completeAndSaveSignature = function () {
    return $scope
      .fetchClientSignatures()
      .then(function () {
        var data = {
          pdfTemplate: ApplicationSvc.params.behaviour.TSSPDFTEMPLATE,
          signDetails: {
            pWhoSigned: ApplicationSvc.currentUser.UserName,
            pSignerPosition: '',
            pLatitude: '',
            pLongitude: '',
            pSignature: '',
            pLocationName: '',
            ptimestamp: '',
            pEmail: ''
          },
          pSignatureType: 'CLIENT',
          pTempProvTimesheetID: $scope.ProvTSID,
          pLogo: ApplicationSvc.params.behaviour.TSSLOGOFILE,
          pURLRequestCode: null,
          pEmailRequested: false,
          pEmail: '',
          pNotes: `useragent=${navigator.userAgent}`,
          theRecord: $scope.theRecord,
          tags: $scope.tags,
          shiftDates: $scope.shiftDates,
          timesheetShifts: $scope.timesheetShifts,
          timesheetTimes: $scope.timesheetTimes,
          timesheetRates: $scope.timesheetRates.filter(function (rate) {
            return rate.IsExpenses === false
          }),
          TimeSheetExpenses: $scope.TimeSheetExpenses,
          terminology: $scope.divisionTimesheetSigningTerminology,
          state: $scope.state,
          divisionTimesheetSigningRights: $scope.divisionTimesheetSigningRights,
          clientSignatures: $scope.timesheetSignatures
        }
        return $scope.exec('pdfTemplate/timesheet', data)
      })
      .then(function () {
        return $scope.authorise()
      })
      .catch(function (res) {
        console.error(res)
        return FormSvc.alert('Error', 'Something went wrong, please try again later.', 'error')
      })
  }

  $scope.signShift = function (shift) {
    $timeout(function () {
      var canvas = document.querySelector('canvas')
      $scope.signaturePad = new SignaturePad(canvas, {})
      $scope.showSignForm = true
    }, 1)

    return FormSvc.modalForm($scope, 'signForm', {}, 'xl', {})
      .then(function () {
        if ($scope.signaturePad.isEmpty()) {
          FormSvc.alert('Error', 'Signature is empty, please re-sign the Shift.', 'error')
          return $scope.signShift(shift)
        } else {
          FormSvc.alert('Shift Signed', 'Thank you for your time', 'success')
        }

        return $scope.exec('timesheets/sign', {
          TempProvTimesheetID: $scope.theRecord.tempprovtimesheetid,
          tempshiftid: shift.tempshiftid,
          timeStamp: moment().format('DD/MM/YYYY HH:mm:ss'),
          whoSigned: ApplicationSvc.currentUser.UserName,
          signatureBlob: $scope.signaturePad.isEmpty() ? null : $scope.signaturePad.toDataURL('image/png')
        })
      })
      .then(function (response) {
        shift.isSigned = true
      })
      .then($scope.fetchClientSignatures)
  }

  $scope.resetCanvas = function () {
    $scope.signaturePad.clear()
  }

  $scope.duplicateShift = function (shift) {
    $scope.editShift(shift, true, true)
  }

  $scope.fetchTimesheetTimes = function () {
    return $scope.fetch({
      fetchAPI: 'callresult/netprovtimesheettimes?pTempProvTimesheetID=' + $scope.ProvTSID,
      fetchTarget: 'timesheetTimes',
      multiRow: true,
      dateFields: ['weekstartdate', 'shiftdate'],
      timeFields: ['timefrom'],
      booleanFields: ['dayticked'],
      numberFields: ['hours']
    })
  }

  $scope.checkHourTotals = function () {
    $scope.state.hourTotalsMismatch = false
    if (!$scope.state.calculated) {
      return
    }
    if (!($scope.state.shiftTimesheet || $scope.state.timeTimesheet)) {
      return
    }
    $scope.timesheetRatesHourTotal = FormSvc.arrayTotal($scope.timesheetRates, 'Units', function (rt) {
      return !rt.IsExpenses && rt.UnitDescription.match(/^hour/i)
    })
    if ($scope.state.shiftTimesheet) {
      $scope.timesheetShiftsHourTotal = FormSvc.arrayTotal($scope.timesheetShifts, $scope.shiftLength, function (sh) {
        return sh.tick
      })
    } else {
      $scope.timesheetShiftsHourTotal = FormSvc.arrayTotal($scope.timesheetTimes, 'hours')
    }
  }

  $scope.checkForRateContent = function () {
    var haveDates = false
    angular.forEach($scope.timesheetRates, function (rt) {
      if (rt.ShiftDate && !rt.IsExpenses) {
        haveDates = true
      }
    })
    $scope.state.rateDates = haveDates
  }

  $scope.getTotal = function () {
    var res = 0
    angular.forEach($scope.timesheetRates, function (value, key) {
      if(value.IsExpenses === false) {
        res += Number(value.Total)
      }
    })
    return res
  }

  $scope.getTotalHours = function () {
    var res = 0
    angular.forEach($scope.timesheetRates, function (value, key) {
      if(value.IsExpenses === false) {
        res += Number(value.Units)
      }
    })
    return res
  }

  $scope.fetchTimesheetRates = function () {
    return $scope
      .fetch({
        fetchAPI: 'callresult/netprovtimesheetrates?pTempProvTimesheetID=' + $scope.ProvTSID,
        fetchTarget: 'timesheetRates',
        multiRow: true,
        booleanFields: ['IsExpenses', 'CanEdit', 'CanEditUnits', 'AddExpenseImageToInvoice', 'ExpenseImageRequired', 'ExpenseImageAllowed'],
        numberFields: ['Units', 'Rate']
      })
      .then(function () {
        return ApiSvc.fetch($scope, {
          fetchAPI: 'callresult/NetProvTimesheetExpenseRatesSelect?pTempProvTimesheetID=' + $scope.ProvTSID, // fetch the pay bands
          fetchTarget: 'paybandTypes',
          multiRow: true
        })
      })
      .then(function () {
        $scope.TimeSheetExpenses = $filter('filter')($scope.timesheetRates, function (o) {
          if (o.IsExpenses == true && o.Total > 0) {
            return o
          }
        })
        $scope.hasTimesheetExpensesAvailable = $scope.paybandTypes.length > 0 || $scope.userClass() === 'CLIENT'
        $scope.checkHourTotals()
      })
      .then(function () {
        $scope.checkForRateContent()
      })
  }

  $scope.deleteRate = function (expense) {
    return $scope
      .fetch({
        fetchAPI: 'callresult/NetProvTimesheetExpenseLineDelete?pTempProvTimesheetLineID=' + expense.TempProvTimesheetLineID,
        fetchTarget: 'timeSheetExpenseDelete',
        multiRow: false
      })
      .then(function () {
        if ($scope.checkForError($scope.timeSheetExpenseDelete.pResult)) {
          $scope.fetchTimesheetRates()
        } else {
          FormSvc.alert('error', $scope.timeSheetExpenseDelete.pResult, 'error')
          $scope.fetchTimesheetRates()
        }
      })
  }

  $scope.fetchShiftTypes = function () {
    return $scope
      .fetch({
        fetchAPI: 'callresult/netshifttypes',
        fetchTarget: 'shiftTypes',
        multiRow: true
      })
      .then(function () {
        // if ($scope.shiftTypes.length) { $scope.state.useShiftTypes = true }
      })
  }

  $scope.fetchQueryType = function () {
    return $scope.fetch({
      fetchAPI: 'callresult/NetTimesheetQueryType',
      fetchTarget: 'queryType'
    })
  }

  $scope.sendTimesheetQueryForm = function () {
    var divisionID = $scope.userClass() === 'CANDIDATE' ? ApplicationSvc.currentUser.registrationDetails.DivisionID : ApplicationSvc.currentUser.divisionid
    return $scope
      .fetch({
        fetchAPI: 'callresult/NetTimesheetQueryReasons?pUserType=' + ($scope.userClass() === 'CANDIDATE' ? 'Cand' : 'Client') + '&pDivisionID=' + divisionID,
        fetchTarget: 'queryReasons',
        multiRow: true
      })
      .then(function () {
        return FormSvc.modalForm($scope, 'timesheetQueryReasonForm', {}, 'md', {
          label: 'col-sm-3',
          data: 'col-sm-7'
        }).then(function (reasonModel) {
          return $scope
            .exec('call/NetTimesheetQueryInsert', {
              pReasonCode: reasonModel.pReasonCode,
              pTempprovTimesheetID: $scope.ProvTSID,
              pNotes: reasonModel.pNotes
            })
            .then(function (response) {
              SweetAlert.swal({
                title: 'Query Sent',
                text: '',
                type: 'success'
              })
            })
        })
      })
  }

  $scope.moveShift = function (shift) {
    $scope.availableShifts = []
    return $scope
      .fetch({
        fetchAPI: 'callresult/NetCandidateVacanciesForMoveShift?pTempShiftID=' + shift.tempshiftid,
        fetchTarget: 'availableShifts',
        multiRow: true
      })
      .then(function () {
        var data = {
          selectedShift: shift.tempshiftid,
          shifts: $scope.availableShifts,
          choices: [
            {
              desc: 'Cancel',
              type: 'danger',
              code: ''
            }
          ]
        }
        return FormSvc.modalInfo($scope, 'timesheetMoveShift', data)
      })
  }

  $scope.moveTheShift = function (selectedShift, shift, close) {
    // The actual moving of the shift
    close() // close the modal
    return $scope
      .exec('call/NetCandidateMoveShift', {
        pTempShiftID: selectedShift,
        pNewVacancyID: shift.pVacancyID
      })
      .then(function (response) {
        $scope.load()
        if (response.IQXResult.attrs.success === '1') {
          // it got mooooved
          sessionStorage.removeItem('TSCREATE')
          return FormSvc.alert('Success', 'Shift moved.', 'success')
        } else {
          return FormSvc.alert('Error', 'Something went wrong moving the shift.', 'error')
        }
      })
  }

  $scope.load = function () {
    // Load whole timesheet
    $scope.theRecord = {}

    if ($scope.userClass() === 'CANDIDATE' && $scope.isSwitchedOn('FETCHCANDTSSET') && BehaviourSvc.isSwitchedOn('TSSDISABLE') !== true) {
      // Timesheet Signing
      $scope.state = {
        loaded: false, // The provisional timesheet was successfully loaded
        calculated: false, // The calculated timesheet lines/rates are available
        completed: false, // Timesheet has been flagged as completed
        showingDetails: true, // Display the shifts/time details
        shiftTimesheet: false, // This is a shift timesheet
        shiftBreaks: false, // There is a non-zero break in one or more of the shifts
        shiftRefs: false, // There is a shift reference in one or more of the shifts
        rateDates: false, // Some of the rates have dates
        timeTimesheet: false, // This is a pseudo-shift timesheet
        contractTimesheet: false, // This timesheet has neither shifts nor pseudo-shifts
        useShiftTypes: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.useShiftTypes : false,
        hourTotalsMismatch: false, // Used to display a warning when the shift hours don't match the rate hours
        allowedToAuthorise: $scope.userHasRight('AUTHORISETIMESHEETS'), // May be over-ridden after fetching
        allowedToApprove: $scope.userHasRight('APPROVETIMESHEETS'), // May be over-ridden after fetching
        canEditTheirRef: $scope.userClass() == 'CLIENT' || $scope.userClass() == 'CANDIDATE',
        canEditDescription: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.editShiftDescription : $scope.userHasRight('TSCANEDITDESCRIPTION'),
        canEditBreak: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.editShiftBreak : $scope.userHasRight('TSCANEDITBREAK'),
        showEdit: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.showEdit : true,
        canMoveShift: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.moveShifts : $scope.userHasRight('CANDCANMOVESHIFT'),
        minuteStep: $scope.userHasRight('TS15MININCREMENT') ? 15 : 5,
        showRates: $scope.isSwitchedOn('FETCHCANDTSSET') && $scope.userClass() !== 'CLIENT' ? $scope.divisionTimesheetSigningRights.showRates : $scope.userHasRight('TSSHOWRATES'),
        showGrades: $scope.isSwitchedOn('FETCHCANDTSSET') && $scope.userClass() !== 'CLIENT' ? $scope.divisionTimesheetSigningRights.showRates : $scope.userHasRight('TSSHOWGRADE'),
        showPaymentType: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.showPaymentType : true,
        canAddShift: false,
        canCopyShift: false,
        canDuplicateShift: false,
        canDeleteShift: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.allowDeleteShift : $scope.isSwitchedOn('TSALLOWCANCELSHIFT'),
        canCopyPayLines: $scope.userHasRight('TSCANEDITCALCULATED'),
        allowMismatchCalculated: $scope.userHasRight('TSALLOWCALCMISMATCH'),
        imageRequired: $scope.userHasRight('TSMUSTUPLOADIMAGE'),
        imageAllowed: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.allowUploadingTimesheetImage : $scope.userHasRight('TSCANUPLOADIMAGE') || $scope.userHasRight('TSMUSTUPLOADIMAGE'),
        canSendAndApprove: $scope.userHasRight('TSSENDANDAPPROVE'),
        canSignOnDevice: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.allowSignOnDevice : $scope.userHasRight('TSSENDAPPROVALLINK'),
        canSendLinkForApprove: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.allowSignViaSendLink : $scope.userHasRight('TSSENDAPPROVALLINK'),
        allowUntickCalc: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.allowUntickCalc : $scope.isSwitchedOn('TSALLOWUNTICKCALC'),
        showTotalHoursCalc: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.showTotalHoursCalc : false,
        canEditShiftDate: $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.canEditShiftDate : !$scope.userHasRight('TSEDITSHIFTDATE'),
        tsHasAllSigs: false,
        expenseEdit: ''
      }
    } else {
      // Everyone else
      $scope.state = {
        loaded: false, // The provisional timesheet was successfully loaded
        calculated: false, // The calculated timesheet lines/rates are available
        completed: false, // Timesheet has been flagged as completed
        showingDetails: true, // Display the shifts/time details
        shiftTimesheet: false, // This is a shift timesheet
        shiftBreaks: false, // There is a non-zero break in one or more of the shifts
        shiftRefs: false, // There is a shift reference in one or more of the shifts
        rateDates: false, // Some of the rates have dates
        timeTimesheet: false, // This is a pseudo-shift timesheet
        contractTimesheet: false, // This timesheet has neither shifts nor pseudo-shifts
        useShiftTypes: false, // Allow specification of shift type when adding/editing shift
        hourTotalsMismatch: false, // Used to display a warning when the shift hours don't match the rate hours
        allowedToAuthorise: $scope.userHasRight('AUTHORISETIMESHEETS'), // May be over-ridden after fetching
        allowedToApprove: $scope.userHasRight('APPROVETIMESHEETS'), // May be over-ridden after fetching
        canEditTheirRef: $scope.userClass() == 'CLIENT' || $scope.userClass() == 'CANDIDATE',
        showEdit: true,
        canEditDescription: $scope.userHasRight('TSCANEDITDESCRIPTION'),
        canEditBreak: $scope.userHasRight('TSCANEDITBREAK'),
        canMoveShift: $scope.userHasRight('CANDCANMOVESHIFT'),
        minuteStep: $scope.userHasRight('TS15MININCREMENT') ? 15 : 5,
        showRates: $scope.userHasRight('TSSHOWRATES'),
        showGrades: $scope.userClass() !== 'CLIENT' ? $scope.userHasRight('TSSHOWGRADE') : false,
        showPaymentType: true,
        canAddShift: false,
        canCopyShift: false,
        canDeleteShift: $scope.isSwitchedOn('TSALLOWCANCELSHIFT'),
        canCopyPayLines: $scope.userHasRight('TSCANEDITCALCULATED'),
        allowMismatchCalculated: $scope.userHasRight('TSALLOWCALCMISMATCH'),
        imageRequired: $scope.userHasRight('TSMUSTUPLOADIMAGE'),
        imageAllowed: $scope.userHasRight('TSCANUPLOADIMAGE') || $scope.userHasRight('TSMUSTUPLOADIMAGE'),
        canSendAndApprove: $scope.userHasRight('TSSENDANDAPPROVE'),
        canSendLinkForApprove: false,
        allowUntickCalc: $scope.isSwitchedOn('TSALLOWUNTICKCALC'),
        showTotalHoursCalc: true,
        canEditShiftDate: !$scope.userHasRight('TSEDITSHIFTDATE'),
        canSignOnDevice: false,
        clientSignMulti: $scope.divisionTimesheetSigningRights.clientSignMulti
      }
    }

    return $scope
      .fetchQueryType()
      .then($scope.fetchTimesheet)
      .then(function () {
        if (!$scope.theRecord.allowedToAuthorise) {
          $scope.state.allowedToAuthorise = false
        }
        if (!$scope.theRecord.allowedToApprove) {
          $scope.state.allowedToApprove = false
        }
        if ($scope.theRecord.timesheettype == 'S') {
          $scope.state.shiftTimesheet = true
          $scope.state.canAddShift = $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.addShifts : $scope.theRecord.ShiftsOnContractTimesheet && $scope.userHasRight('TSCANADDSHIFT')
          $scope.state.canCopyShift = $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.canCopyShift : $scope.userHasRight('TSCANADDSHIFT')
          $scope.state.canDuplicateShift = $scope.isSwitchedOn('FETCHCANDTSSET') ? $scope.divisionTimesheetSigningRights.canDuplicateShift : false
          return $scope.fetchTimesheetShifts()
        } else if ($scope.theRecord.timesheettype == 'T') {
          $scope.state.timeTimesheet = true
          return $scope.fetchTimesheetTimes()
        }
      })
      .then(function () {
        if (!($scope.state.shiftTimesheet || $scope.state.timeTimesheet)) {
          $scope.state.contractTimesheet = true
        }
        if ($scope.theRecord.completed || $scope.state.contractTimesheet) {
          $scope.state.calculated = true
          $scope.state.completed = $scope.theRecord.completed
          $scope.state.showingDetails = !$scope.theRecord.completed
          return $scope.fetchTimesheetRates()
        }
      })
      .then(function () {
        if ($scope.theRecord.ShiftsOnContractTimesheet) {
          if ($scope.state.useShiftTypes === true) {
            return $scope.fetchShiftTypes()
          }
          $scope.shiftTypes = {}
          // Don't use shift type combo
        } else {
          return $scope.fetchShiftTypes()
        }
      })
      .then(function () {
        if (!$scope.state.completed) {
          return $timeout($scope.setEditing, 0, true, true) // Wrap in timeout to ensure DOM is built and ready first
        }
      })
  }

  $scope.addShift = function (sh, bCopy) {
    // Add a completely new shift
    var addedShiftID = null
    sh = {
      pTempProvTimesheetID: $scope.ProvTSID
    }
    sh.shiftTypes = angular.copy($scope.shiftTypes)
    $scope.timesheetDlgCaption = 'Details'

    if ($scope.isSwitchedOn('FETCHCANDTSSET') && $scope.divisionTimesheetSigningRights.useNewShiftTemplate === true) {
      sh.timefrom = moment($scope.divisionTimesheetSigningRights.newShiftStart, 'HH:mm').toDate()
      sh.timeto = moment($scope.divisionTimesheetSigningRights.newShiftEnd, 'HH:mm').toDate()
      sh.breakminutes = $scope.divisionTimesheetSigningRights.newShiftBreak
    }

    FormSvc.modalForm($scope, 'timesheetShiftEdit', sh, 'md', {
      label: 'col-sm-3',
      data: 'col-sm-7'
    })
      .then(function (sh) {
        return $scope.exec('call/NetProvTimesheetShiftAdd', $scope.addableShift(sh))
      })
      .then(function (newShiftID) {
        addedShiftID = newShiftID.IQXResult.IQXSuccess.attrs.id
        $scope.state.calculated = false
        return $scope.fetchTimesheetShifts()
      })
      .then(function () {
        if ($scope.state.shiftTimesheet === true) {
          if ($scope.checkShifts() === true) {
            FormSvc.alert('Notice', 'You have tried to add an overlapping shift that has been automatically removed.', 'info')
            return $scope
              .exec('call/NetProvTimesheetShiftCancel', {
                ptempshiftid: addedShiftID
              })
              .then($scope.fetchTimesheetShifts)
          }
        }
      })
  }

  $scope.editShift = function (sh, bCopy, bNextDay) {
    // Edit an individual shift - optionally a new one created by duplication
    sh = angular.copy(sh) // Start by making a copy
    if (bNextDay) {
      sh.shiftdate = moment(sh.shiftdate).add(1, 'days').toDate()
    }
    sh.shiftTypes = angular.copy($scope.shiftTypes)
    if (sh.tempshifttypeid && !FormSvc.arrayFoundValue(sh.shiftTypes, 'TempShiftTypeID', sh.tempshifttypeid)) {
      // Ensure that the current tempshifttypeid is in the choice array even if not web published
      sh.shiftTypes.unshift({
        TempShiftTypeID: sh.tempshifttypeid,
        Description: sh.tempshifttypedesc
      })
    }
    $scope.timesheetDlgCaption = 'Details'
    if (bCopy) {
      $scope.timesheetDlgCaption = 'New Shift' + $scope.timesheetDlgCaption
      if (sh.tempshiftid.substr(0, 5) !== 'Copy_') {
        sh.tempshiftid = 'Copy_' + sh.tempshiftid
      }
      sh.referencecode = ''
    }
    FormSvc.modalForm($scope, 'timesheetShiftEdit', sh, 'md', {
      label: 'col-sm-3',
      data: 'col-sm-7'
    })
      .then(function (sh) {
        return $scope.exec('call/NetProvTimesheetShiftSet', $scope.saveableShift(sh))
      })
      .then(function () {
        $scope.state.calculated = false
        $scope.fetchTimesheetShifts()
      })
  }

  $scope.deleteShift = function (sh) {
    // Cancel the shift
    ApplicationSvc.queryMessage('Please Confirm', 'Remove this shift because it was not worked?')
      .then(function () {
        return $scope.exec('call/NetProvTimesheetShiftCancel', {
          ptempshiftid: sh.tempshiftid
        })
      })
      .then(function () {
        $scope.state.calculated = false
        $scope.fetchTimesheetShifts()
      })
  }

  $scope.saveableShift = function (sh) {
    // The post object for the NetProvTimesheetShiftSet api
    return {
      ptempshiftid: sh.tempshiftid,
      pshiftdate: ApiSvc.DateToString(sh.shiftdate),
      ptimefrom: ApiSvc.TimeToString(sh.timefrom),
      ptimeto: ApiSvc.TimeToString(sh.timeto),
      pbreakminutes: sh.breakminutes,
      preferencecode: sh.referencecode,
      ptempshifttypeid: $scope.state.useShiftTypes ? sh.tempshifttypeid : undefined
    }
  }

  $scope.addableShift = function (sh) {
    // The post object for the NetProvTimesheetShiftAdd api
    return {
      ptempprovtimesheetid: $scope.ProvTSID,
      pshiftdate: ApiSvc.DateToString(sh.shiftdate),
      ptimefrom: ApiSvc.TimeToString(sh.timefrom),
      ptimeto: ApiSvc.TimeToString(sh.timeto),
      pbreakminutes: sh.breakminutes,
      preferencecode: sh.referencecode,
      ptempshifttypeid: $scope.state.useShiftTypes ? sh.tempshifttypeid : undefined
    }
  }

  $scope.editTime = function (sh) {
    // Edit an individual time
    $scope.timesheetDlgCaption = $filter('date')(sh.shiftdate, 'EEEE dd/MM/yyyy')
    sh = angular.copy(sh) // Avoid changing original if cancelled
    FormSvc.modalForm($scope, 'timesheetTimeEdit', sh, 'md', {
      label: 'col-sm-3',
      data: 'col-sm-7'
    })
      .then(function (sh) {
        return $scope.exec('call/NetProvTimesheetTimeSet', $scope.saveableTime(sh))
      })
      .then(function () {
        $scope.state.calculated = false
        $scope.fetchTimesheetTimes()
      })
  }

  $scope.saveableTime = function (sh) {
    // The post object for the NetProvTimesheetTimeSet api
    return {
      ptempshiftid: sh.tempshiftid,
      pplacementid_date: sh.placementid + '_' + ApiSvc.DateToString(sh.shiftdate),
      phours: sh.hours,
      ptimefrom: ApiSvc.TimeToString(sh.timefrom)
    }
  }

  $scope.unCalculateTimesheet = function () {
    // Indicate that re-calculation is required
    $scope.state.calculated = false
  }

  $scope.showDetails = function () {
    // Switch on the times/shifts visibility
    $scope.state.showingDetails = true
  }

  $scope.shiftLength = function (sh) {
    // Shift duration in hours
    var start = moment().hours(sh.timefrom.getHours()).minutes(sh.timefrom.getMinutes())
    var end = moment().hours(sh.timeto.getHours()).minutes(sh.timeto.getMinutes())
    var len = end.diff(start, 'hours', true)
    if (len < 0) {
      len = 24.0 + len
    } // Overnight
    if (sh.breakminutes) {
      len = len - sh.breakminutes / 60
    }
    len = Math.round(len * 100) / 100 // round to 2 dp
    return len
  }

  $scope.saveableRate = function (rt) {
    // The post object for the NetProvTimesheetRateSet api
    if (rt.IsExpenses) {
      return {
        pTempProvTimesheetLineID: rt.TempProvTimesheetLineID,
        pUnitDescription: rt.UnitDescription,
        pUnits: rt.Units,
        pRate: rt.Rate
      }
    } else {
      return {
        pTempProvTimesheetLineID: rt.TempProvTimesheetLineID,
        pUnits: rt.Units,
        pUnitDescription: $scope.state.contractTimesheet ? 'Units Edited' : undefined // Means edited rates will NOT be overwritten by calculation on contract timesheets but they WILL on shift and time timesheets
      }
    }
  }

  $scope.editExpense = function (rt, bCopy, editOpen = false, noSave = false) {
    // Edit a timesheet rate or expenses line - optionally a new one created by duplication
    $scope.state.expenseEdit = rt.TempProvTimesheetLineID
    if (!editOpen && noSave) {
      // Edit Closed Without Save, Fetch To Get Old Results
      $scope.state.expenseEdit = ''
      $scope.fetchTimesheetRates()
      return
    }
    if (!editOpen && !bCopy) {
      if ($scope.TimeSheetExpenses[0].TempProvTimesheetLineID == 'expense-temp') {
        // new expense
        if ('UnitDescription' in $scope.TimeSheetExpenses[0] && 'Rate' in $scope.TimeSheetExpenses[0] && 'Units' in $scope.TimeSheetExpenses[0]) {
          let data = $scope.TimeSheetExpenses[0]
          data.payband = $scope.selects.payBandType
          $scope
            .exec('call/NetProvTimesheetExpenseLineCreate', {
              pTempProvTimesheetID: $scope.ProvTSID,
              pTempPayBandID: data.payband.TempPaybandID,
              pDescription: data.UnitDescription,
              pChargeRate: data.Rate,
              pUnitsCharged: data.Units
            })
            .then(function (res) {
              FormSvc.alert('Added', data.UnitDescription, 'success')
              $scope.fetchTimesheetRates()
            })
        } else {
          $scope.TimeSheetExpenses.shift()
        }
        return
      }
      rt = angular.copy(rt) // Start by making a copy
    } else if (bCopy) {
      // Duplicate
      rt.ShiftDate = 'New'
      if (rt.TempProvTimesheetLineID.substr(0, 5) !== 'Copy_') {
        rt.TempProvTimesheetLineID = 'Copy_' + rt.TempProvTimesheetLineID
      }
    }
    if (rt.Units === 0) {
      return FormSvc.alert('', 'Please contact the agency to set units to 0.')
    }
    $scope.exec('call/NetProvTimesheetRateSet', $scope.saveableRate(rt))
    setTimeout(function () {
      // Wait for Save
      $scope.fetchTimesheetRates()
    }, 200)
    if (!editOpen) {
      $scope.state.expenseEdit = ''
    }
  }

  $scope.editRate = function (rt, bCopy) {
    // Edit a timesheet rate or expenses line - optionally a new one created by duplication
    rt = angular.copy(rt) // Start by making a copy
    if (bCopy) {
      rt.ShiftDate = 'New'
      if (rt.TempProvTimesheetLineID.substr(0, 5) !== 'Copy_') {
        rt.TempProvTimesheetLineID = 'Copy_' + rt.TempProvTimesheetLineID
      }
    }
    if (rt.IsExpenses) {
      $scope.timesheetDlgCaption = rt.ShiftDate + ' Expense Line'
      var dlg = 'timesheetExpenseEdit'
    } else {
      $scope.timesheetDlgCaption = rt.ShiftDate + ' Pay Line'
      var dlg = 'timesheetRateEdit'
    }
    FormSvc.modalForm(
      $scope,
      dlg,
      rt,
      'md',
      {
        label: 'col-sm-3',
        data: 'col-sm-7'
      },
      {},
      {},
      true
    )
      .then(function (rt) {
        if (rt.Units === 0) {
          return FormSvc.alert('', 'Please contact the agency to set units to 0.')
        }
        return $scope.exec('call/NetProvTimesheetRateSet', $scope.saveableRate(rt))
      })
      .then(function () {
        $scope.fetchTimesheetRates()
      })
  }

  $scope.calcTimeTimesheet = function () {
    // Execute the rate script for a non-shift timesheet
    return $scope
      .exec('service/ProvNonShiftTSProcessRateScript', {
        id: $scope.ProvTSID
      })
      .then(function () {
        $scope.state.calculated = true
        return $scope.fetchTimesheetRates()
      })
  }

  function momentDateTime(jsDate, jsTime) {
    return moment(moment(jsDate).format('YYYY-MM-DD') + ' ' + moment(jsTime).format('HH:mm'), 'YYYY-MM-DD HH:mm')
  }

  $scope.checkShifts = function () {
    let i
    let j
    for (i = 0; i < $scope.timesheetShifts.length; i++) {
      for (j = 0; j < $scope.timesheetShifts.length; j++) {
        if (i != j) {
          let s1 = $scope.timesheetShifts[i]
          let s2 = $scope.timesheetShifts[j]
          let shift1start = momentDateTime(s1.shiftdate, s1.timefrom)
          let shift1end = momentDateTime(s1.shiftdate, s1.timeto)
          if (shift1start.isAfter(shift1end)) {
            shift1end.add(1, 'days')
          }
          let shift2start = momentDateTime(s2.shiftdate, s2.timefrom)
          let shift2end = momentDateTime(s2.shiftdate, s2.timeto)
          if (shift2start.isAfter(shift2end)) {
            shift2end.add(1, 'days')
          }

          if (shift1start.isBefore(shift2end) && shift1end.isAfter(shift2start)) {
            return true
          }
        }
      }
    }
  }

  $scope.calc = function () {
    // Execute the rate script on the selected data
    if ($scope.isSwitchedOn('PROVTSNOSERIALWARN') && ($scope.theRecord.serialnumber === '' || !$scope.theRecord.serialnumber)) {
      return FormSvc.alert('error', 'Timesheet missing serial number, please contact the agency.', 'error')
    }

    if ($scope.state.shiftTimesheet === true) {
      if ($scope.checkShifts() === true) {
        return FormSvc.alert('error', 'You have overlapping shifts, please amend', 'error')
      }

      var shiftCount = 0
      angular.forEach($scope.timesheetShifts, function (shift) {
        if (shift.tick === true) {
          shiftCount++
        }
      })
      if (shiftCount === 0) {
        return FormSvc.alert('No shifts to calculate', 'You need to include at least one shift.', 'error')
      }
    }
    $scope.timesheetRates = []
    if ($scope.timesheetShifts) {
      if ($scope.timesheetShifts.length === 0) {
        // Timesheet with 0 shifts!
        return FormSvc.alert('No shifts to calculate', 'Please contact the agency', 'error')
      }
    }

    if ($scope.state.timeTimesheet) {
      return $scope.calcTimeTimesheet().then($scope.getExpenseImages)
    } // Re-direct to the non-shift procedure
    var aShifts = []
    angular.forEach($scope.timesheetShifts, function (value) {
      if (value.tick) {
        if ($scope.isSwitchedOn('TSBLOCKFUTURESHIFTS')) {
          /* Just used for calculations and are NOT sent to IQX */
          var shiftDate = moment(value.shiftdate)
          var shiftStartTime = moment(value.timefrom)
          var shiftEndTime = moment(value.timeto)

          if (shiftStartTime.isAfter(shiftEndTime)) {
            shiftDate = shiftDate.add(1, 'd')
          }

          var shiftEnd = moment(shiftDate.format('DD/MM/YYYY') + ' ' + shiftEndTime.format('HH:mm'), 'DD/MM/YYYY HH:mm')
          /* ** */

          if ($scope.divisionTimesheetSigningRights.hoursLeeway > 0) {
            shiftEnd = shiftEnd.subtract($scope.divisionTimesheetSigningRights.hoursLeeway, 'hours')
          }

          if (moment().isBefore(shiftEnd)) {
            value.tick = false
            return toastSvc.info('Future Shift', 'Some shifts have been excluded as they are in the future.', 'futureShifts', 5000)
          }
        }
        aShifts.push(value.tempshiftid)
      }
    })
    if (aShifts.length !== 0) {
      return $scope
        .exec('call/NetProvTimesheetShiftsSelect', {
          pTempProvTimesheetID: $scope.ProvTSID,
          pShiftList: aShifts.join()
        })
        .then(function () {
          return $scope.exec('service/ProvTSProcessRateScript', {
            id: $scope.ProvTSID
          })
        })
        .then(function () {
          $scope.state.calculated = true
          return $scope.fetchTimesheetRates()
        })
        .then($scope.getExpenseImages)
    }
  }

  $scope.getExpenseImages = function () {
    // Get expense images
    return $scope
      .fetch({
        fetchAPI: 'callresult/NetProvTimesheetExpenseImages?pTempProvTimesheetID=' + $scope.ProvTSID,
        fetchTarget: 'expenseImages',
        multiRow: true
      })
      .then(function () {
        $scope.TimeSheetExpenses.forEach(function (expense) {
          expense.images = []
          $scope.expenseImages.filter(function (img) {
            if (img.timesheetlineid === expense.TempProvTimesheetLineID) {
              expense.images.push(img)
              return img
            }
          })
        })
      })
  }

  $scope.viewExpenseImage = function (img) {
    return $http
      .get('/api/document/doxi', {
        params: {
          class: 'O',
          ext: 'pdf',
          id: img.PDFImageBlobID
        }
      })
      .then(function (res) {
        $window.open('/api/document/download?doxi=' + res.data, '_blank')
      })
  }

  $scope.viewExpenseImages = function (expense) {
    var data = {
      expense: expense,
      choices: [
        {
          desc: 'Close',
          type: 'danger',
          code: ''
        }
      ]
    }
    return FormSvc.modalInfo($scope, 'manageExpenseImages', data, 'lg').catch(function (err) {
      //do nothing with error (as it'll just be a UI thing saying "back drop clicked")
    })
  }

  $scope.deleteExpenseImage = function (img, $close) {
    return $scope
      .exec('call/NetProvTimesheetExpenseImageDelete', {
        pTempProvTimesheetID: $scope.ProvTSID,
        pPDFExtraDocumentID: img.PDFExtraDocumentID
      })
      .then(function () {
        toastSvc.success('Success', 'Expense Image Deleted.', 'expdel')
        return $close()
      })
      .then($scope.getExpenseImages)
  }

  $scope.createOLEDocTS = function () {
    if ($scope.isSwitchedOn('TSUPLOADIMGTOBLOB')) {
      return $scope.exec('call/NetProvTimesheetOLEInsert', {
        pProvTimesheetID: $scope.ProvTSID
      })
    } else {
      return $q.when('')
    }
  }

  $scope.createOLEDocExpense = function (expenseLine) {
    return $scope.exec('call/NetProvTimesheetExpenseOLEInsert', {
      pProvTimesheetID: $scope.ProvTSID,
      pTempProvTimesheetLineID: expenseLine.TempProvTimesheetLineID,
      pExpenseDescription: expenseLine.UnitDescription
    })
  }

  $scope.uploadExpenseImage = function (file, expenseLine) {
    expenseLine.imageMissing = false
    toastSvc.info('Uploading', '', 'upload' + expenseLine.linenumber, 1000000)

    var oledocid = ''
    var blobid = ''
    const headerStr = `${$scope.userName()} | TS: ${$scope.theRecord.serialnumber} | Line: ${expenseLine.linenumber} | ${expenseLine.UnitDescription}`

    return $scope
      .createOLEDocExpense(expenseLine)
      .then(function (res) {
        oledocid = res.IQXResult.IQXSuccess.attrs.message
        return Upload.upload({
          url: '/api/document/upload',
          file: file,
          fileFormDataName: 'file',
          headers: {
            'X-Auth': ApplicationSvc.currentUser.token
          },
          fields: {
            CLASS: 'O',
            ID: oledocid,
            ZIP: 0,
            Type: 'TE',
            toPDF: 'Y',
            header: headerStr
          }
        })
      })
      .then(function (res) {
        ApiSvc.CheckIQXResult(res.data) // Checks the IQXResult construct and, if failed, throws exception with the message
        blobid = res.data.IQXResult.IQXSuccess.attrs.id
        return $timeout(function () {}, 2000) // Display the Upload complete message for 2 seconds before refreshing and cleaning up
      }, null) // 3rd arg is the progress callback
      .then(function (res) {
        return $scope.exec('call/NetProvTimesheetExpenseOLEInsert', {
          pProvTimesheetID: $scope.ProvTSID,
          pTempProvTimesheetLineID: expenseLine.TempProvTimesheetLineID,
          pExpenseDescription: expenseLine.UnitDescription,
          pOLEDocID: oledocid,
          pBlobID: blobid
        })
      })
      .then($scope.fetchTimesheetRates) // Fetch the rates again after the upload is complete
      .then($scope.getExpenseImages) // Get the images again after the upload is complete
      .then(function () {
        toastSvc.clear('upload' + expenseLine.linenumber)
        return toastSvc.success('Success', 'Expense Image Uploaded.', 'expimg')
      })
  }

  $scope.uploadImage = function (file) {
    var uploadFields = {}
    var OLEDocumentID = ''

    $scope.downloadError = '' // Occupies same position as uploadProgress
    if ($scope.uploadProgress || !file) {
      return
    } // Currently uploading or invalid call
    if (file.$error) {
      var errorMap = {}
      errorMap[file.$error] = true // Create map object for ngMessages
      FormSvc.modalInfo($scope, 'timesheetImageError', {
        error: errorMap,
        choices: [
          {
            desc: 'Ok',
            type: 'primary',
            code: ''
          }
        ]
      })
      return
    }
    return $scope
      .createOLEDocTS()
      .then(function (rtrn) {
        if (rtrn) {
          OLEDocumentID = rtrn.IQXResult.IQXSuccess.attrs.message
        }

        if ($scope.isSwitchedOn('TSUPLOADIMGTOBLOB')) {
          uploadFields = {
            CLASS: 'O',
            ID: OLEDocumentID,
            ZIP: 1,
            Type: 'TIMESHEET',
            ProvTimesheetID: $scope.ProvTSID,
            toPDF: 'Y'
          }
        } else {
          uploadFields = {
            Type: 'TIMESHEET',
            ProvTimesheetID: $scope.ProvTSID,
            toPDF: 'Y'
          }
        }

        $scope.showUploadProgress()
        return Upload.upload({
          url: '/api/document/upload',
          file: file,
          fileFormDataName: 'file',
          headers: {
            'X-Auth': ApplicationSvc.currentUser.token
          },
          fields: uploadFields
        })
      })
      .then(
        function (res) {
          ApiSvc.CheckIQXResult(res.data) // Checks the IQXResult construct and, if failed, throws exception with the message
          $scope.uploadProgress = 'Upload complete'
          return $timeout(function () {}, 2000) // Display the Upload complete message for 2 seconds before refreshing and cleaning up
        },
        null,
        $scope.showUploadProgress
      ) // 3rd arg is the progress callback
      .then(function () {
        $scope.uploadProgress = ''
        $scope.theRecord.hasScannedImage = true
      })
      .catch(function (err) {
        $scope.uploadProgress = ''
        FormSvc.alert('Upload Error', err.iqxError.text, 'error')
        if ($scope.isSwitchedOn('TSUPLOADIMGTOBLOB')) {
          return $scope.exec('call/NetProvTimesheetImageDelete', {
            pProvTimesheetID: $scope.ProvTSID,
            pOLEDocumentID: OLEDocumentID
          })
        }
      })
  }

  $scope.showUploadProgressToast = function (evt) {}

  $scope.showUploadProgress = function (evt) {
    var s = 'Uploading...'
    if (evt && evt.total) {
      // progress callback
      s = s + parseInt((100.0 * evt.loaded) / evt.total) + '%'
    }
    $scope.uploadProgress = s
  }

  $scope.downloadImage = function () {
    $scope.downloadError = ''
    $http
      .get('/api/document/doxi', {
        params: {
          Type: 'TIMESHEET',
          ProvTimesheetID: $scope.ProvTSID
        }
      })
      .then(function (res) {
        $window.open('/api/document/download?doxi=' + res.data, '_blank')
      })
      .catch(function (err) {
        $scope.downloadError = ApiSvc.ExtractError(err)
      })
  }

  $scope.save = function () {
    // Save reference, questionnaire etc.
    return FormSvc.update($scope, true)
  }

  $scope.checkForHoursMismatch = function () {
    if ($scope.state.hourTotalsMismatch) {
      var sMess = 'Shift hours do not match timesheet line hours.'
      if ($scope.state.allowMismatchCalculated) {
        return ApplicationSvc.queryMessage('Mismatch', sMess + ' Is this ok?') // Returns rejected promise if they say No
      } else {
        ApplicationSvc.showMessage('Mismatch', sMess, true)
        return $q.reject('')
      }
    }
    return $q.when('Ok to proceed')
  }

  $scope.checkImageRequirement = function () {
    if ($scope.state.imageRequired && !$scope.theRecord.hasScannedImage) {
      FormSvc.alert('Error', 'You must upload a timesheet image before completing.', 'error')
      return $q.reject('')
    }

    var expImagesMissing = false

    $scope.TimeSheetExpenses.forEach(function (exp) {
      if (exp.ExpenseImageRequired && exp.hasImage === null) {
        exp.imageMissing = true
        expImagesMissing = true
      }
    })

    if (expImagesMissing) {
      FormSvc.alert('Error', 'You must upload expense images before completing.', 'error')
      return $q.reject('')
    } else {
      return $q.when('Ok to proceed')
    }
  }

  $scope.generateTSNumber = function () {
    if ($scope.isSwitchedOn('INCALLPROVTS')) {
      // is it switched on??
      if (!$scope.theRecord.serialnumber) {
        // do we have a serial number
        return $scope.exec('call/NetProvTimesheetSetTSNumber', {
          pTempProvTimesheetID: $scope.ProvTSID
        })
      }
    }
  }

  $scope.complete = function () {
    // Mark calculated timesheet as completed
    $scope.formError = ''
    return $scope
      .checkImageRequirement()
      .then($scope.checkForHoursMismatch)
      .then($scope.generateTSNumber)
      .then($scope.save)
      .then(function () {
        return $scope.exec('call/NetProvTimesheetComplete', {
          pTempProvTimesheetID: $scope.ProvTSID
        })
      })
      .then(function () {
        $scope.state.completed = true
        $scope.setEditing(false)
      })
  }

  $scope.undo = function () {
    // Reverse complete() and return to edit mode
    $scope.formError = ''
    return $scope
      .exec('call/NetProvTimesheetComplete', {
        pTempProvTimesheetID: $scope.ProvTSID,
        pInstruction: 'REVERSE'
      })
      .then(function () {
        $scope.state.completed = false
        $scope.state.showingDetails = true
        $scope.setEditing(true)
      })
  }

  $scope.authorise = function () {
    // Client authorisation of timesheet
    $scope.formError = ''
    if (!$scope.state.allowedToAuthorise) {
      return $q.reject(FormSvc.alert('Error', 'Permission denied.', 'error'))
    }
    return $scope
      .checkForHoursMismatch()
      .then($scope.save)
      .then(function () {
        return ApplicationSvc.messageDialog('Authorise Timesheet', $scope.params.lang.pages.timesheets.auth.disclaimer + ' Are you sure?', 'Yes', 'No')
      })
      .then(function () {
        if ($scope.state.shiftTimesheet) {
          return $scope.exec('service/ProvTSComplete', {
            ID: $scope.ProvTSID
          })
        } else {
          return $scope.exec('service/ProvNonShiftTSComplete', {
            ID: $scope.ProvTSID
          })
        }
      })
      .then(function () {
        return $scope.exec('call/NetAudit', {
          pActionType: 'TIMESHEETAUTHORISE',
          pDescription: 'Number ' + $scope.theRecord.serialnumber,
          pRecordID: $scope.theRecord.serialnumber
        })
      })
      .then(function () {
        if ($scope.state.allowedToApprove && $scope.userHasRight('AUTOAPPROVETIMESHEET')) {
          // Approve immediately
          return $scope.exec('call/NetTimesheetIDFromSerialNumber', {
            pSerialNumber: $scope.theRecord.serialnumber
          })
        }
      })
      .then(function (res) {
        if (res) {
          // NetTimesheetIDFromSerialNumber was called and returned successfully
          var tsid = res.IQXResult.IQXSuccess.attrs.id // id will be empty if could not uniquely match the serialnumber
          if (tsid) {
            return $scope.exec('call/NetTimesheetApprove', {
              pTempTimesheetList: tsid
            })
          }
        }
      })
      .then(function () {
        // Prov TS no longer exists - go back to list
        ApplicationSvc.navigate('/provtimesheets/fill') // This forces the path change even if the modal dialog has not yet cleaned up
      })
  }

  $scope.sendMessage = function () {
    sendMessageDialogSvc.createMessageFromDialog($scope, 'TIMESHEET', 'Query Timesheet ' + $scope.theRecord.serialnumber, {
      pprovtimesheetid: $scope.ProvTSID
    })
  }

  $scope.checkForError = function (string) {
    if (string.substring(0, 1) == '9') {
      return false
    } else {
      return true
    }
  }

  $scope.addExpense = function () {
    if ($scope.TimeSheetExpenses[0] && $scope.TimeSheetExpenses[0].TempProvTimesheetLineID == 'expense-temp') {
      return FormSvc.alert('Error', 'You already have a new expense open', 'error')
    } else {
      return FormSvc.modalForm(
        $scope,
        'timesheetExpensesv2',
        {},
        'md',
        {
          label: 'col-sm-2',
          data: 'col-sm-10'
        },
        {},
        {},
        false
      )
        .then(function (data) {
          $scope.TimeSheetExpenses.unshift({
            TempProvTimesheetLineID: 'expense-temp',
            pTempPayBandID: $scope.selects.payBandType
          })
          $scope.state.expenseEdit = $scope.TimeSheetExpenses[0].TempProvTimesheetLineID
        })
        .catch(function (e) {
          if (e.message) {
            return FormSvc.alert('Error', e, 'error')
          }
        })
    }
  }

  $scope.uploadCleanup = function () {
    $scope.reset()
    $scope.uploadProgress = ''
    $scope.uploadError = ''
    $scope.theRecord = {}
    $scope.tags = []
  }

  $scope.uploadExpense = function (file) {
    $scope.setSubmitted(true) // Ensure all validation errors appear
    if ($scope.uploadProgress || $scope.theForm.$invalid) {
      return
    }
    $scope.uploadError = ''
    $scope.showUploadProgress()
    Upload.upload({
      url: '/api/document/upload',
      file: file,
      fileFormDataName: 'file',
      headers: {
        'X-Auth': ApplicationSvc.currentUser.token
      },
      fields: {}
    })
      .then(
        function (res) {
          ApiSvc.CheckIQXResult(res.data) // Checks the IQXResult construct and, if failed, throws exception with the message
          $scope.uploadProgress = 'Upload complete'
          return $timeout(function () {}, 2000) // Display the Upload complete message for 2 seconds before refreshing and cleaning up
        },
        null,
        $scope.showUploadProgress
      ) // 3rd arg is the progress callback
      .then(function () {
        $scope.uploadCleanup()
        $scope.fetchTimesheetRates()
      })
  }

  $scope.completeandsendforapprovalButtonText = ApplicationSvc.params.lang.pages.timesheets.current.completeandsendforapproval
  $scope.sendforapprovalButtonText = ApplicationSvc.params.lang.pages.timesheets.current.sendforapproval
  $scope.popuptitle = ApplicationSvc.params.lang.pages.timesheets.current.popuptitle

  $scope.DoSendAndApprove = function () {
    FormSvc.modalForm($scope, 'timesheetSendAndApprove', {}, 'md', {
      label: 'col-sm-3',
      data: 'col-sm-7'
    }).then(function (post) {
      post.faxnumber = post.faxnumber ? post.faxnumber : null
      post.emailaddress = post.emailaddress ? post.emailaddress : null

      if (post.faxnumber == null && post.emailaddress == null) {
        return FormSvc.alert('Error', 'Please enter an email address or fax number', 'error')
      }
      return $scope
        .exec('call/NetProvTimesheetSendForApproval', {
          ptempprovtimesheetid: $scope.ProvTSID,
          pfaxnumber: post.faxnumber,
          pemailaddress: post.emailaddress
        })
        .then(function () {
          FormSvc.alert('Sent for Approval', 'Timesheet has been submitted', 'success')
        })
    })
  }

  $scope.addEmailAddress = function (scope) {
    if (scope.theRecord.emailaddress && scope.theRecord.emailaddress !== '') {
      $scope.emailList.push(scope.theRecord.emailaddress)
      scope.theRecord.emailaddress = ''
    }
  }

  $scope.removeEmailFromList = function (i) {
    $scope.emailList.splice(i, 1)
  }

  $scope.reportBadEmailUse = function (badEmail, usedOwnEmail) {
    return ApiSvc.exec($scope, 'call/NetCandidateTSBadEmail', {
      pAttemptedEmail: badEmail,
      pPersonID: ApplicationSvc.currentUser.personID,
      usedOwnEmail: usedOwnEmail
    })
  }

  $scope.selectEmailAddress = function (email) {
    $scope.emailList.push(email)
  }

  $scope.clearEmailList = function () {
    localStorage.removeItem('signingemails')
    $scope.emailQuickList = []
  }

  $scope.DoSendLinkForApproval = function () {
    var badEmailList = []
    $scope.emailQuickList = []
    if ($scope.isSwitchedOn('FETCHSIGNINGCONTACTS')) {
      ApiSvc.fetch($scope, {
        fetchAPI: 'callresult/NetTimesheetSigningContacts?pTempProvTimesheetID=' + $scope.ProvTSID,
        fetchTarget: 'TimesheetSigningContacts',
        multiRow: true
      })
    } else {
      $scope.emailQuickList = JSON.parse(localStorage.getItem('signingemails'))
      if (!$scope.emailQuickList) {
        $scope.emailQuickList = []
      }
    }

    ApiSvc.exec($scope, 'candidate-json/bad-email-domains', {}).then(function (badEmails) {
      badEmailList = badEmails.IQXResult.Row.emails
    })

    FormSvc.modalForm($scope, 'timesheetSendLinkForApprove', {}, 'md', {
      label: 'col-sm-3',
      data: 'col-sm-7'
    }).then(function (post) {
      if ($scope.emailList.length > 0) {
        // We have some emails in the list to send to
        if (post.emailaddress || post.emailaddress !== '') {
          // if there is a valid email in the textbox, add it to the list
          $scope.emailList.push(post.emailaddress)
        }
        post.emailaddress = $scope.emailList.join(';') // email list string
      } else {
        if (post.emailaddress === null || !post.emailaddress || post.emailaddress === '') {
          // if the email field is empty
          FormSvc.alert('Error', 'Please enter an email address.', 'error')
          return $scope.DoSendLinkForApproval()
        } else {
          $scope.emailList.push(post.emailaddress)
        }
      }

      var emailError = false

      $scope.emailList.forEach(function (email) {
        // BAD EMAILS
        if (!email) {
          return
        }
        if (email.includes(ApplicationSvc.currentUser.registrationDetails.EmailAddress)) {
          $scope.emailList = []
          FormSvc.alert('Error', $scope.terminology.authorisedEmailSignersOnly, 'error')
          $scope.reportBadEmailUse(email, 1)
          emailError = true
          return $scope.DoSendLinkForApproval()
        }

        var emailDomain = email.substring(email.lastIndexOf('@') + 1)
        if (badEmailList.includes(emailDomain)) {
          $scope.emailList = []
          FormSvc.alert('Error', $scope.terminology.authorisedEmailSignersOnly, 'error')
          $scope.reportBadEmailUse(email, 0)
          emailError = true
          return $scope.DoSendLinkForApproval()
        }

        $scope.emailQuickList.push(email)
      })

      if (emailError) {
        return false
      }

      localStorage.setItem('signingemails', JSON.stringify([...new Set($scope.emailQuickList)]))

      var pURLRequestCode = base64Svc.encode(`${$scope.ProvTSID}|${post.emailaddress}|${moment().toISOString()}`)

      return $scope
        .exec('call/NetProvTimesheetSendLinkForApprovalSet', {
          ptempprovtimesheetid: $scope.ProvTSID,
          pemail: post.emailaddress,
          pURLRequestCode: pURLRequestCode
        })
        .then(function () {
          if ($scope.state.completed === false) {
            return $scope.complete()
          } else {
            return
          }
        })
        .then(function () {
          $scope.emailList = []
          SweetAlert.swal({
            title: 'Sent for Approval',
            text: 'Timesheet has been submitted',
            type: 'success'
          })
          $timeout(function () {
            return $location.path('/provtimesheets/fill')
          }, 500)
        })
    })
  }

  $scope.confirmCompleteAndSignNow = function () {
    if ($scope.divisionTimesheetSigningRights.candidateConfirmTimesheetSign === true) {
      SweetAlert.swal({
        text: $scope.terminology.candidateConfirmTimesheetSignMessage,
        confirmButtonText: 'Continue',
        showCancelButton: true,
        type: 'warning'
      }).then(function (res) {
        if (res.value && res.value === true) {
          // confirmed...
          $scope.completeAndSignNow()
        }
      })
    } else {
      $scope.completeAndSignNow()
    }
  }

  $scope.completeAndSignNow = function () {
    var pURLRequestCode = base64Svc.encode(`${$scope.ProvTSID}|signnow|${moment().toISOString()}`)

    return $scope
      .exec('call/NetProvTimesheetSendLinkForApprovalSet', {
        ptempprovtimesheetid: $scope.ProvTSID,
        pSignOnDevice: 1,
        pURLRequestCode: pURLRequestCode
      })
      .then(function () {
        if ($scope.state.completed === false) {
          return $scope.complete()
        }
      })
      .then(function () {
        return $location.url('/timesheetsigning/' + pURLRequestCode + '?authenticated=1')
      })
  }

  $scope.getDivisionTimesheetSigningRightsAndTerms = function () {
    $scope.setEditing(true)
    $scope.divisionTimesheetSigningRights = BehaviourSvc.timesheetSigningSettings()
    $scope.divisionTimesheetSigningTerminology = $scope.terminology
    return $q.resolve()
  }

  $scope.duplicateMulti = function (shift) {
    // shift = clicked / selected shift
    var start = moment($scope.shiftDates.startdate)
    var end = moment($scope.shiftDates.enddate)

    var days = []
    var theDate = start.clone()
    while (theDate.isSameOrBefore(end)) {
      days.push({
        date: theDate.clone(),
        selected: false,
        template: moment(shift.shiftdate).isSame(theDate, 'day'),
        inTimesheetAlready:
          $scope.timesheetShifts.filter(function (row) {
            return moment(row.shiftdate).isSame(theDate, 'day')
          }).length > 0
      })
      theDate.add(1, 'day')
    }

    var x = {
      shift: shift,
      dates: $scope.shiftDates,
      position: $scope.theRecord.position,
      days: days
    }

    return FormSvc.modalForm($scope, 'duplicateMulti', x, 'md', {
      label: 'col-sm-3',
      data: 'col-sm-7'
    }).then(function (rtrn) {
      var selectedDays = rtrn.days.filter(function (elm) {
        return elm.selected && !elm.template
      })
      var i = 0

      function addShiftRecursive() {
        if (i >= selectedDays.length) {
          $scope.state.calculated = false
          $scope.fetchTimesheetShifts()
          return
        }
        var sh = angular.copy(shift)
        sh.shiftdate = selectedDays[i].date.toDate()
        sh.tempshiftid = 'Copy_' + sh.tempshiftid
        $scope.exec('call/NetProvTimesheetShiftSet', $scope.saveableShift(sh)).then(function () {
          i++
          addShiftRecursive()
        })
      }
      addShiftRecursive()
    })
  }

  $scope.help = function () {
    var data = {
      choices: [
        {
          desc: 'Close',
          type: 'danger',
          code: ''
        }
      ]
    }
    return FormSvc.modalInfo($scope, 'timesheetHelp', data, 'lg')
  }

  $scope.autoCalc = function () {
    if ($scope.userHasRight('TSAUTOCALCULATE')) {
      $scope.calc()
    }
  }

  $scope.fetchClientSignatures = function () {
    return $scope
      .fetch({
        fetchAPI: 'timesheets/getsignatures/' + $scope.ProvTSID,
        fetchTarget: 'timesheetSignatures',
        multiRow: true
      })
      .then(function () {
        $scope.shiftswithsignatures = []
        $scope.timesheetSignatures.forEach(function (signature) {
          $scope.shiftswithsignatures.push(signature.tempshiftid)
        })

        $scope.timesheetShifts.forEach(function (shift) {
          if ($scope.shiftswithsignatures.includes(shift.tempshiftid)) {
            shift.isSigned = true
          } else {
            shift.isSigned = false
          }
          var shiftDate = moment(shift.shiftdate)
          var shiftStartTime = moment(shift.timefrom)
          var shiftEndTime = moment(shift.timeto)

          if (shiftStartTime.isAfter(shiftEndTime)) {
            shiftDate = shiftDate.add(1, 'd')
          }
          var shiftEnd = moment(shiftDate.format('DD/MM/YYYY') + ' ' + shiftEndTime.format('HH:mm'), 'DD/MM/YYYY HH:mm')
          if ($scope.divisionTimesheetSigningRights.hoursLeeway > 0) {
            shiftEnd = shiftEnd.subtract($scope.divisionTimesheetSigningRights.hoursLeeway, 'hours')
          }

          if (moment().isBefore(shiftEnd)) {
            shift.isFuture = true
          }
        })

        $scope.state.tsHasAllSigs = $scope.timesheetShifts.filter((x) => !x.isSigned).length === 0
      })
  }

  // The initialisation code:
  if ($scope.ProvTSID) {
    TerminologySvc.getTerminology()
      .then(function (value) {
        $scope.terminology = value
        if ((ApplicationSvc.currentUser.UserClass === 'CANDIDATE' && $scope.isSwitchedOn('FETCHCANDTSSET') && BehaviourSvc.isSwitchedOn('TSSDISABLE') !== true) || ApplicationSvc.currentUser.UserClass === 'CLIENT') {
          $timeout(function () {
            return $scope
              .getDivisionTimesheetSigningRightsAndTerms()
              .then($scope.load)
              .then($scope.autoCalc)
              .then(function () {
                if (BehaviourSvc.isSwitchedOn('TSSCLIENTSIGNMULTI') === true) return $scope.fetchClientSignatures()
              })
          }, 1)
        } else {
          $scope
            .load()
            .then(function () {
              TerminologySvc.getTerminology().then(function (value) {
                $scope.terms = value
              })
            })
            .then($scope.autoCalc)
            .then(function () {
              if (BehaviourSvc.isSwitchedOn('TSSCLIENTSIGNMULTI') === true) return $scope.fetchClientSignatures()
            })
        }
      })
      .catch(function (error) {
        console.error(error)
      })
  } else {
    FormSvc.alert('error', 'Timesheet ID not specified', 'error')
  }
})
